export const QUERY_USER_KEY = "user";
export const QUERY_PACKAGE_KEY = "package"
export const QUERY_CAR_MAKE_KEY = "car-make";
export const QUERY_CAR_MODEL_KEY = "car-model";
export const QUERY_CAR_MODEL_VARIANT_KEY = "car-variant";
export const QUERY_RTO_KEY = "rto";
export const QUERY_STATE_KEY = "state";
export const QUERY_CITY_KEY = "city";
export const QUERY_PROVIDER_KEY = "provider";
export const QUERY_FUEL_KEY = "fuel";
export const QUERY_BODY_TYPE_KEY = "body-type";
export const QUERY_SEGMENT_KEY = "segement";
export const QUERY_PROVIDER_FUEL_KEY = "provider-fuel";
export const QUERY_PROVIDER_SEGMENT_KEY = "provider-segment";
export const QUERY_PROVIDER_BODY_TYPE_KEY = "provider-body-type";
export const QUERY_PROVIDER_MAKE_KEY = "provider-make";
export const QUERY_PROVIDER_MODEL_KEY = "provider-model";
export const QUERY_PROVIDER_VARIANT_KEY = "provider-variant";
export const QUERY_PROVIDER_RTO_KEY = "provider-rto";
export const QUERY_PROVIDER_STATE_KEY = "provider-state";
export const QUERY_PROVIDER_CITY_KEY = "provider-city";

export const QUERY_FILE_KEY = "file";
export const QUERY_ORDER_KEY = "order";
export const QUERY_QUERY_KEY = "query";
export const QUERY_AUTHOR_KEY = "author";
export const QUERY_BLOG_KEY = "blog";
export const QUERY_APPLICATION_KEY = "application";
export const QUERY_TESTIMONIAL_KEY = "testimonial";
export const QUERY_HOMEPAGE_KEY = "homepage";
export const QUERY_ACTIVATION_KEY = "activation-key";

export const QUERY_SPECIALITY_KEY = "specialities";
export const QUERY_ABOUT_US_KEY = "aboutUs";
export const QUERY_MEDICAL_TEAM = "medical-team,";

export const QUERY_SERVICES_KEY = "services";
export const QUERY_APPOINTEMENT_KEY = "appointment";
export const QUERY_CIRCULAR_KEY = "hospitalCircular";
export const QUERY_MAGAZINE_KEY = "magazine";

export const QUERY_APPLICANTS_KEY = 'applicants'
export const QUERY_FEEDBACK_KEY = 'feedback'
export const QUERY_HIRING_KEY = 'hiring'
export const QUERY_CONTACT_KEY = 'contact'
export const QUERY_OPINION_KEY = 'opinion'
export const QUERY_GALLERY_KEY = 'gallery'
export const QUERY_BUY_PACKAGE_KEY = 'contact'
export const QUERY_EXPORT_DATA_KEY = "export-data";
export const QUERY_SLOTS_KEY = "slots";

export const QUERY_COMPLIANCE_KEY = "compliance";
export const QUERY_HEADING_KEY = "page-headings";
export const QUERY_FLEET_KEY = "fleet";
export const QUERY_ANNUAL_REPORTS_KEY = "annual-reports";
export const QUERY_RESTRICTED_BAGGAGE_KEY = "restricted-baggage";
export const QUERY_BAGGAGE_TABLE_KEY = "baggage-table";
export const QUERY_MANAGE_ADDRESS_KEY = "address-manage";
export const QUERY_SUB_ADMIN_KEY = "sub-admin";





export const QUERY_HOSPITAL_ADDRESS_KEY = "hospital-address";
export const QUERY_FAQ_KEY = "faqs";


